module.exports = __webpack_public_path__ + "static/media/blue-close.987f9956.svg";